import React, { useEffect } from 'react';
import { SelectInput, FormDataConsumer, useInput, useListContext } from 'react-admin';
import { useFormContext } from 'react-hook-form';

import styles from './styles.module.scss';

const NestedSelectInput = props => {
  // eslint-disable-next-line react/prop-types
  const {source, fstSource, sndSource, fstLabel, sndLabel, fstChoices, getSndChoices, validate, variant} = props;
  const { filter, setFilters, displayedFilters } = useListContext();
  const { setValue } = useFormContext();
  const { id } = useInput({ source });

  const firstLevelSourceName = fstSource;
  const secondLevelSourceName = sndSource;

  // Clean up form values when filter is removed (component unmounts).
  // Deferred to avoid re-triggering react-admin's auto-show behavior.
  useEffect(() => {
    return () => {
      // Remove both levels from filters
      const { [firstLevelSourceName]: _, [secondLevelSourceName]: __, [id]: ___, ...restFilters } = filter;
      const { [id]: ____, ...restDislpayedFilters} = displayedFilters;
      
      setFilters(restFilters, restDislpayedFilters);
    };
  }, [firstLevelSourceName, secondLevelSourceName, setValue]);

  const getSndChoicesFromFirstValueId = valueID => {
    // eslint-disable-next-line react/prop-types
    const fstChoice = fstChoices.find(c => c.id === valueID);
    return fstChoice ? getSndChoices(fstChoice) : [];
  };

  return (
      <>
        <SelectInput
            source={firstLevelSourceName}
            choices={fstChoices}
            label={fstLabel}
            className={styles.noHelperText}
            validate={validate}
            variant={variant}
            onChange={() => setValue(secondLevelSourceName, null)}
        />
        &nbsp;
        <FormDataConsumer>
          {({formData, ...rest}) => {
            const choices = formData[firstLevelSourceName] ? getSndChoicesFromFirstValueId(formData[firstLevelSourceName]) : [];
            return formData &&
                (
                    <SelectInput
                        
                        source={secondLevelSourceName}
                        choices={choices}
                        label={sndLabel}
                        className={styles.noHelperText}
                        validate={validate}
                        initialValue={null}
                        variant={variant}
                        {...rest}
                    />
                )
          }
          }
        </FormDataConsumer>
      </>
  );
};

export default NestedSelectInput;
